import TagLocationMarker from './tagsLocationMarker';

export * from './tagsLocationMarker';

export default TagLocationMarker;
